export const prettifyRole = (userRole: string): string => {
  if (userRole === 'eleve') return 'élève';
  if (userRole === 'professeur') return 'professeur';
};
